// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import loading from '../../../../share/components/vue/ProcessingIcon';
import config from '../../../../share/config';
import { mapState } from 'vuex';
import logWrapper from '../../../../share/logWrapper';
import util from '../../../../share/util/utils';

export default {

  data() {
    return {
      modelUpdateProcessing: true,
      // turnIgOnChecked: false,
      processing: false,

      // 各種ダイアログの変数
      modalconfirmtostartkeylessaccessimmobilizerregistrationregKeylessImbType3: false,
      modalprocessisgoingonregKeylessImbType3: false,
      modalconfirmtoexecutekeylessaccessCMregistrationregKeylessImbType3: false,
      modaltheproperaccesskeysshouldbeconfirmedregKeylessImbType3: false,
      modalcheckingownerregKeylessImbType3: false,
      modalaccessKeyregisteringregKeylessImbType3: false,
      modalaccessKeyregisterlimitregKeylessImbType3: false,
      modalignitiononregKeylessImbType3: false,
      modalsuccessregKeylessImbType3: false,
      modalerrfailedregKeylessImbType3: false,
    };
  },
  props: {
    registerKeyLessImbOkButtonClick: Function,
    onNotifyOkButtonPushedRegImbSysAPICall: Function,
    callRegKeylessImbEndOfKeyRegistraion: Function,
    onErrornotifyEndOfProcessRegImbSys: Function,
    imbStatusInfo: Object,
    onSetEndOfProcessingFlag: Function,
    isCausesAndActionDialog: Function,
    changeProcessingStatus: Function,
    modalShowInfo: {
      type: Object,
      require: false,
      default: () => ({ id: "", isShow: false }),
    },
  },

  components: {
    'processing-view': loading,
  },

  computed: {
    ...mapState({
      isNorthAmerica: state => state.userProperty.region === config.REGION_NORTH_AMERICA,
      vehicle: state => state.vehicle,
    }),
  },

  watch: {
    processing: function (value) {
      this.changeProcessingStatus(value);
    },
    modalShowInfo: {
      handler(value) {
        if (value) {
          const id = value.id.replace(/-/g, "");
          if (util.hasPropertyCheck(this, id)) {
            this[id] = value.isShow;
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    registrationOkButtonClick: async function () {
      this.dialogCloseProcess();
      await this.onNotifyOkButtonPushedRegImbSysAPICall();
    },
    accessKeyQuitButtonClick: async function () {
      this.dialogCloseProcess();
      await this.callRegKeylessImbEndOfKeyRegistraion();
    },
    accessKeyOkButtonClick: async function () {
      this.dialogCloseProcess();
      await this.callRegKeylessImbEndOfKeyRegistraion();
    },
    onErrorKeylessOkButtonClick: async function () {
      this.processing = true;
      this.dialogCloseProcess();
      await this.onErrornotifyEndOfProcessRegImbSys();
      this.processing = false;
      this.determineEndOfProcessingFlag();
    },
    AddUnderline: function (string) {
      return string.replace(/<br\/>.+/g, '<u>$&</u>');
    },
    successOkButtonClick: function () {
      this.dialogCloseProcess();
      this.determineEndOfProcessingFlag();
    },
    cancelButtonClick: function () {
      this.dialogCloseProcess();
      this.determineEndOfProcessingFlag();
    },
    determineEndOfProcessingFlag: function () {
      if (this.vehicle.vehicleInfo === null) {
        logWrapper.log('vehicle information is ', this.vehicle.vehicleInfo);
        this.onSetEndOfProcessingFlag();
      }
    },
    modalShowWEvent: function (mode) {
      const info = { id: this.modalShowInfo.id, isShow: false, nextModal: this.modalShowInfo.nextModal };
      if (mode === "show") {
        info.isShow = true;
      }
      this.$emit("modalDisplayStatus", info);
    },

    dialogCloseProcess: function () {
      const id = this.modalShowInfo.id.replace(/-/g, "");
      if (util.hasPropertyCheck(this, id)) {
        this[id] = false;
      }
    }

  },

  created() { },

};